import { FC } from 'react';
import ViewUpload from '~/components/ViewUpload';

type FileUploadAnswerProps = {
    answer: {
        name: string;
        upload: unknown;
        content_type: string;
    };
};
const FileUploadAnswer: FC<FileUploadAnswerProps> = ({ answer }) => {
    function isImage(contentType: string) {
        return contentType?.startsWith('image/');
    }

    return (
        <div>
            <ViewUpload
                file={answer.upload}
                name={answer.name}
                isImage={isImage(answer.content_type)}
            />
        </div>
    );
};
export default FileUploadAnswer;
